import { useContext } from 'react'
import LoaderContext from '../contexts/LoaderProvider'

const useLoader = () => {
    return useContext(LoaderContext)
}

export default useLoader
